import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { UsersIcon, StarIcon, ShieldCheckIcon, HeartHandshakeIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
const points = [{
  icon: UsersIcon,
  text: 'Adulto y niño trabajan en equipo'
}, {
  icon: StarIcon,
  text: 'Se celebran los avances'
}, {
  icon: ShieldCheckIcon,
  text: 'Se refuerza la confianza'
}, {
  icon: HeartHandshakeIcon,
  text: 'No hay castigos ni presión'
}];
export function AccompanimentSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <SectionWrapper background="white" data-id="element-20">
      <div ref={ref} className="grid md:grid-cols-2 gap-12 items-center" data-id="element-21">
        {/* Content */}
        <div className="order-2 md:order-1" data-id="element-22">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-8" data-id="element-23">
            Acompañar en lugar de corregir
          </h2>

          <p className="text-navy/70 text-lg mb-8 leading-relaxed" data-id="element-24">
            Este método está diseñado para que el proceso sea una experiencia
            positiva para toda la familia. No se trata de corregir un problema,
            sino de acompañar un aprendizaje natural.
          </p>

          <ul className="space-y-4" data-id="element-25">
            {points.map((point, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            delay: 0.2 + index * 0.1
          }} className="flex items-center gap-4 bg-light-blue p-4 rounded-xl" data-id="element-26">
                <span className="flex-shrink-0 w-10 h-10 rounded-full bg-soft-blue/20 flex items-center justify-center" data-id="element-27">
                  <point.icon className="w-5 h-5 text-soft-blue" data-id="element-28" />
                </span>
                <span className="text-navy font-medium" data-id="element-29">{point.text}</span>
              </motion.li>)}
          </ul>
        </div>

        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={isInView ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        duration: 0.6
      }} className="order-1 md:order-2" data-id="element-30">
          <img src="https://cdn.magicpatterns.com/uploads/cKxKiUtc4vKccJJuafn9En/3._img_pipi_landing.png" alt="Madre e hijo trabajando juntos en el seguimiento del método" className="w-full h-auto rounded-2xl shadow-lg" data-id="element-31" />
        </motion.div>
      </div>
    </SectionWrapper>;
}